var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"value":_vm.show,"prominent":"","type":"error"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "+_vm._s(_vm.text)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }